//import axios from 'axios'

const state = {
  nome: null,
  cognome: null,
  nazioneNascita: { CODICENU: null, DECODIF: null },
  comuneNascita: { CODICECOMUNE: null, DECODIF: null },
  dataNascita: null,
  linguaMadre: { CODICENU: null, DESCRIZIONE: null },
  statoCivile: { CODICENU: null, DECODIF: null },
  sesso: null,
  religione: { CODICENU: null, descrbreve: null },
  cittadinanza1: { CODICENU: null, DECODIF: null },
  cittadinanza2: { CODICENU: null, DECODIF: null },
  ordineReligioso: { CODICENU: null, DECODIF: null },
  codiceFiscale: "",
  diocesi: { CODICE: null, DIOCESI: null },
  collegio: { CODICE: null, COLLEGIO: null },
};
const getters = {};
const actions = {
  async salvaDati({ commit }, payload) {
    await commit(payload.azione, payload.dati);
  },
};
const mutations = {
  setIscrizione: (state, dati) => {
    alert(JSON.stringify(dati));
    //state.riepilogo.iscrizione.facolta.val = dati.fac_scelta.CODICENU
    //state.riepilogo.iscrizione.facolta.desc = dati.fac_scelta.DECODIF
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
